import Cookies from 'js-cookie'
import $ from 'jquery'
export default {
  getTranslated: (state) => (locale, submodule, key) => {
    let selections = state[submodule].selections;

    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedOptionsList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }

    if (!selections) {
      return [];
    }

    let result = selections.filter((item) => {
      return key === item.name;
    }).map((item) => {
      return {
        name: item.name,
        options: item.options.map((item) => {
          return {
            value: item.selectionKey,
            text: item[selectionItemToBeGet]
          }
        })
      }
    });
    return result.length > 0 ? result[0].options : [];
  },
  getTranslatedArray: (state, getters) => (locale, submodule, key, haveAll = true) => {
    let result = getters.getTranslated(locale, submodule, key);
    if (result.length > 0) {
      if (haveAll) {
        result.unshift({ text: 'All', value: null });
      }
      return result;
    }

    return [];
  },
  getTranslatedValue: (state, getters) => (locale, submodule, type, key) => {
    if (!key) {
      return 'N/A';
    }
    let result = getters.getTranslatedArray(locale, submodule, type)
      .filter((item) => {
        return item.value === key
      });
    if (result.length > 0) {
      return result[0].text;
    }
    return 'N/A';
  },

  getTranslatedData: (state, getters) => (locale, data, key) => { // Data should be object 
    if (!key) {
      return 'N/A';
    }

    // let locale = Cookies.get('locale');
    let language = "";
    switch (locale) {
      case 'zh_mo':
        language = "Hk";
        break;
      case 'zh_hk':
        language = "Hk";
        break;
      case 'zh_cn':
        language = "Hk";
        break;
      case 'en_us':
        language = "En";
        break;
    }
    return data[key + language];
  },

  getImageUrl: (state) => (row) => {
    // console.log(row);
    let url;
    if (row != null) {
      // url = process.env.DOMAIN+'/'+row;
      // url = 'https://www.bidabal.com/bidable' + '/' + row;
      //  url = 'https://test.ftech.com.hk/kol-rest' + '/' + row;
       url = 'https://www.kolpartner.cn/kol-rest' + '/' + row;
    } else {
      url = 'http://www.markweb.in/primehouseware/images/noimage.png';
    }
    // console.log(url);
    return url;
  },
  totalPrice: (state) => {

    var cartProducts = state.cartProducts;
    var totalPrice = 0;

    for (var i = cartProducts.length - 1; i >= 0; i--) {
      totalPrice += cartProducts[i]['unitPrice'] * cartProducts[i]['quantity'];
    }
    return totalPrice;
  },
  totalPricePackages: (state) => {

    var cartPackages = state.cartPackages;
    var totalPrice = 0;

    for (var i = cartPackages.length - 1; i >= 0; i--) {
      totalPrice += cartPackages[i]['unitPrice'] * cartPackages[i]['quantity'];
    }
    return totalPrice;
  },

  totalQuantity: (state) => {

    var cartProducts = state.cartProducts;

    return cartProducts.length;
  },
  totalQuantityPackages: (state) => {

    var cartPackages = state.cartPackages;

    return cartPackages.length;
  },

  tariff: (state, getters) => {
    return getters.totalPrice * state.tariffRate;
  },

  shippingFee: (state,getters) => {
    if(getters.totalPricePackages>=300)
    return state.noShippingFee;
    else
    return state.shippingFee
  },

  shippingFeeProduct: (state,getters) => {
    if(getters.totalPrice>=300)
    return state.noShippingFee;
    else
    return state.shippingFee
  },

  discount: (state, getters) => {
    return getters.totalPrice * state.discountRate;
  },
  getPackageCardQuantityByID: (state) => (productID) => {
    // console.log(productID);
    let cart = state.cartPackages;
    let quantity = 0;
    $.each(cart, (index, product) => {
      if (product.productID == productID) {
        quantity = product.quantity;
      }
    })
    return quantity;
  },
  getProductCardQuantityByID: (state) => (productID,attributeID) => {
    // console.log(productID);
    let cart = state.cartProducts;
    let quantity = 0;
    $.each(cart, (index, product) => {
      if (product.productID == productID && product.attributeID == attributeID) {
        quantity = product.quantity;
      }else if(product.productID == productID){
        quantity = product.quantity;
      }
    })
    return quantity;
  },
  getRouteStatus: (state, getters) => {
    return state.routeStatus;
  },
  getExchangePrice: (state) => (hkPrice) => {
    let price = parseFloat(hkPrice);
    let locale = Cookies.get('locale');
    let rate = 1.0;

    switch (locale) {
      case 'zh_cn':
        price = (price * rate);
        break;
      case 'zh_hk':
        price = (price * 1.0);
        break;
      case 'zh_mo':
        price = (price * 1.03);
        break;
    }

    // price =price.toFixed(2) + "";
    price = Math.round(price);
    return price;
  },

  convertToHKPriceByCurrency:(state) => (currency, originalPrice) => { // Use in order List
    let price = parseFloat(originalPrice);
    // let locale = Cookies.get('locale');
    let rate = 1.0;

    switch (currency) {
      case 'CNY':
        price = (price / rate);
        break;
      case 'HKD':
        price = (price / 1.0);
        break;
      case 'MOP':
        price = (price / 1.03);
        break;
    }
    // price =price.toFixed(2) + "";
    let hkPrice = Math.round(price);
    return hkPrice;
  },
  getPriceByCurrency: (state) => (currency, hkPrice) => { // Use in order List
    let price = parseFloat(hkPrice);
    // let locale = Cookies.get('locale');
    let rate = 1.0;

    switch (currency) {
      case 'CNY':
        price = (price * rate);
        break;
      case 'HKD':
        price = (price * 1.0);
        break;
      case 'MOP':
        price = (price * 1.03);
        break;
    }
    // price =price.toFixed(2) + "";
    price = Math.round(price);
    return price;
  },
  getHKPrice: (state) => (otherPrice) => {
    let price = parseFloat(otherPrice);
    let locale = Cookies.get('locale');
    let rate = 1.0;

    switch (locale) {
      case 'zh_cn':
        price = (price / rate);
        break;
      case 'zh_hk':
        price = (price / 1.0);
        break;
      case 'zh_mo':
        price = (price / 1.03);
        break;
    }
    return price;
  },
  getRoundPrice:(state)=>(priceString)=>{
    return Math.round(parseFloat(priceString));
  },

  getSearchParam:(state)=>{
    return state.SearchParam;
  },
  getFooterCurrentTab:(state)=>{
    return state.currentTab;
  },
  getPercentage:(state)=>(rate)=>{
    let integer = parseInt(rate);
    return integer+"%";
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js